import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const FooterMobile = ({ logout, auth }) => {
  return (
    <section
      className='w-100 d-md-none bg-white shadow-sm'
      style={{ position: 'fixed', bottom: '0', height: '55px' }}
    >
      <div className='row'>
        <div className='col-3'>
          <a
            target='_blank'
            className='w-100 d-flex flex-column align-items-center align-content-center py-3 justify-content-center'
            href='https://portal.izpf.ir'
          >
            <i className='fas fa-graduation-cap text-dark f-24'></i>
          </a>
        </div>
        <div className='col-3'>
          <Link
            className='w-100 d-flex flex-column align-items-center text-center align-content-center py-3 justify-content-center'
            to={auth() ? '/dashboard' : '/'}
          >
            <i className='fas fa-user-alt text-dark f-24'></i>
          </Link>
        </div>
        <div className='col-3'>
          <Link
            className='w-100 d-flex flex-column align-items-center align-content-center py-3 justify-content-center'
            to='/'
          >
            <i className='fas fa-home text-dark f-24'></i>
          </Link>
        </div>
        <div className='col-3'>
          <Link
            onClick={(e) => {
              e.preventDefault();
              if (auth) {
                logout();
              }
            }}
            className='w-100 d-flex flex-column align-items-center align-content-center py-3 justify-content-center'
            to='/'
          >
            <i className={`fas fa-sign-out-alt text-dark f-24`}></i>
          </Link>
        </div>
      </div>
      ;
    </section>
  );
};

FooterMobile.propTypes = {
  auth: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

export default FooterMobile;
